// Router
import { useParams } from 'react-router-dom'

// Component
import ShowServiceCase from '@/components/service_cases/ShowServiceCase'

export default function ServiceDetailPage() {
    const { id } = useParams()

    return <ShowServiceCase serviceCaseId={id} withScrollableScreen={true} />
}
